import { ref } from "vue";

export default () => {
  const APP_VERSION = 'main__$(date +%s)';
  const initDone = ref(false);
  const introDone = ref(false);

  return { state: {initDone, introDone}, consts: { APP_VERSION } };
};
